import React, { useRef } from 'react'
import useModal from '../../../../../utils/hooks/useModal'
import Calendar from 'react-calendar';
import style from './ProductList.module.css'
import { Field } from 'formik';

const ReportModal = ({
    closeModal,
    displayModal,
    reportType,
    setReportType,
    reportInitialDate,
    setReportInitialDate,
    reportEndDate,
    setReportEndDate,
    utilityReport,
    reportByType
}) => {

    const divStyle = {
        display: displayModal ? 'block' : 'none'
    }
    const ref = useRef(null)

    const [refInitialDate, isShowInitialDate, setIsShowInitialDate] = useModal(false)
    const [refEndDate, isShowEndDate, setIsShowEndDate] = useModal(false)

    return (
        <div
            className={`${style.modal}`}
            ref={ref}
            style={divStyle}
            onClick={closeModal}
        >
            <div
                className={`${style.modal_content}`}
                onClick={e => e.stopPropagation()}
            >
                <div className={`${style.center}`}>

                    <div className={`${style.title}`}>Reportes</div>
                    <div className={`${style.subtitle} mt-4`}>Seleccione las opciones</div>

                    <div className='column wrapper-2 mt-3'>
                        <div>Fecha de inicio</div>
                        <input
                            className={`inputs-admin ${style.input_pointer}`}
                            readOnly
                            type="text"
                            value={reportInitialDate.toLocaleDateString()}
                            onClick={() => setIsShowInitialDate(true)}
                        />
                        {isShowInitialDate &&
                            <div ref={refInitialDate} >
                                <div
                                    style={{
                                        display: isShowInitialDate ? 'block' : 'none'
                                    }}
                                    className="calendar-register" >
                                    <Calendar
                                        maxDate={reportEndDate}
                                        onChange={
                                            (dateTime) => {
                                                setReportInitialDate(new Date(dateTime));
                                                setIsShowInitialDate(false)
                                            }
                                        }
                                    />
                                </div>

                            </div>
                        }
                    </div>

                    <div className='column wrapper-2 mt-2'>
                        <div>Fecha de fin</div>
                        <input
                            className={`inputs-admin ${style.input_pointer}`}
                            readOnly
                            type="text"
                            value={reportEndDate.toLocaleDateString()}
                            onClick={() => setIsShowEndDate(true)}
                        />
                        {isShowEndDate &&
                            <div ref={refEndDate} >
                                <div
                                    style={{
                                        display: isShowEndDate ? 'block' : 'none'
                                    }}
                                    className="calendar-register" >
                                    <Calendar
                                        minDate={reportInitialDate}
                                        onChange={
                                            (dateTime) => {
                                                setReportEndDate(new Date(dateTime));
                                                setIsShowEndDate(false)
                                            }
                                        }
                                    />
                                </div>

                            </div>
                        }
                    </div>
                    <div className='column wrapper-2 mt-3'>
                        <div>Tipo de reporte</div>
                        <select
                            className={`inputs-admin ${style.input_pointer}`}
                            onChange={
                                e => {
                                    setReportType(e.target.value);
                                    console.log()
                                }
                            }
                        >
                            <option value='mostSold'>Más vendido</option>

                            <option
                                value={'leastSold'}>
                                {'Menos vendido'}
                            </option>

                        </select>
                    </div>

                    {reportType ==='mostSold' ?
                        <div className={`${style.subtitle} mt-4`}>Producto más vendido</div> :
                        <div className={`${style.subtitle} mt-4`}>Producto menos vendido</div>
                    }
                    <div className='mt-3'>
                        <span>Producto: </span>
                        <span>{reportByType?.product?.name}</span>

                    </div>
                    <div className='mt-2'>
                        <span>Cantidad vendida: </span>
                        <span>{reportByType?.orderedQuantity}</span>
                    </div>

                    <div className={`${style.subtitle} mt-4`}>Reporte de utilidades</div>
                    <div className='mt-3'>
                        <span>Ingreso neto o utilidad: </span>
                        <span>{utilityReport?.utilityProductSuborders}</span>

                    </div>
                    <div className='mt-2'>
                        <span>Ingreso bruto: </span>
                        <span>{utilityReport?.totalPriceSuborders}</span>
                    </div>
                    <div className='mt-2'>
                        <span>Costos de producción: </span>
                        <span>{utilityReport?.totalPriceProductCosts}</span>
                    </div>

                </div>


            </div>

        </div>
    )
}

export default ReportModal